import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import csfIcon from '../images/SealHonorSociety.png';
import styles from './Header.module.css';

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
      <Link to="/" className={styles.logoLink}>
	<img src={csfIcon} alt="CSF Tutors Icon" className={styles.logo} style={{
  	  maxHeight: '60px',
  	  width: 'auto'
	}} />
      </Link>
      
      {/* Mobile menu button */}
      <button 
        className={styles.mobileMenuBtn}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className={`${styles.hamburger} ${mobileMenuOpen ? styles.open : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      {/* Navigation */}
      <nav className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}`}>
        <Link 
          to="/" 
          className={styles.navLink + (location.pathname === '/' ? ' ' + styles.active : '')}
          onClick={() => setMobileMenuOpen(false)}
        >
          Home
        </Link>
        <Link 
          to="/directory" 
          className={styles.navLink + (location.pathname.startsWith('/directory') ? ' ' + styles.active : '')}
          onClick={() => setMobileMenuOpen(false)}
        >
          Find a Tutor
        </Link>
        <Link 
          to="/tutor-register" 
          className={styles.navLink + (location.pathname.startsWith('/tutor-register') ? ' ' + styles.active : '')}
          onClick={() => setMobileMenuOpen(false)}
        >
          Tutor Registration
        </Link>
	<Link 
  	 to="/about" 
  	 className={styles.navLink + (location.pathname.startsWith('/about') ? ' ' + styles.active : '')}
  	 onClick={() => setMobileMenuOpen(false)}
	>
  	 About Us
	</Link>
        <Link 
          to="/directory" 
          className={styles.headerBtn}
          onClick={() => setMobileMenuOpen(false)}
        >
          Get Started
        </Link>
      </nav>
      
      {/* Mobile overlay */}
      {mobileMenuOpen && <div className={styles.overlay} onClick={() => setMobileMenuOpen(false)} />}
    </header>
  );
}
